export default __webpack_public_path__ + "static/stars-90c266f7d69f1ffb6137bfe92b3be444.png";